<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  /**全司注册组件 */
  data() {
    return {
      locale: zhCN,
    };
  },
  computed: {},
  mounted() {
    console.log(this);
  },


  methods: {
    name() {},
  },
};
</script>
<style  lang="less">
// body {
//   background: url("~@/assets/bj.png") no-repeat top left;
//   background-size: 1366px 768px;
// }
.bj {
  width: 1133px;
  position: absolute;
  left: 233px;
  height: 589px !important;
  top: 104px;
}
.ant-modal-mask,
.ant-drawer-mask {
  background-color: rgba(0, 0, 0, 0) !important;
}
.ant-table {
  color: #000000 !important;
}
</style>
